'use client';

import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider } from 'next-intl';
export const IntlProvider = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <NextIntlClientProvider {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};